/* eslint-disable */
(function ($) {
  $('requirement-group').each(function () {
    const key = $(this).data('key');
    $(document).on('change', `input[name="${key}"]`, () => {
      if ($(`summary-block[data-key="${key}"]`).length) {
        $(`summary-block[data-key="${key}"]`).html($(`summary-block[data-key="${key}"]`).html().replace(/,/g, '<br />'));
      }
    });
  });

  // Add listener
  $('.c-event-form__slide').on('change', () => {
    if ($('.c-summary .message > span').css('display') === 'none' && $('.c-summary .fragen').css('display') === 'none') {
      // 'element' is hidden
      $('.c-summary .message').parent().find('.c-summary__title').hide();
    } else {
      $('.c-summary .message').parent().find('.c-summary__title').show();
    }
  });

  /* $('div.o-checkbox-box-grid input[type="checkbox"]').each(function () {
    let key = $(this).attr('name');
     $(document).on('change', `input[name="${key}"]`, function () {
      if ($(`span[data-key="${key}"]`).length) {
        $(`span[data-key="${key}"]`).html($(`span[data-key="${key}"]`).html().replace(/,/g, "<br />"));
      }
    });
  }); */

  if (window.location.href.indexOf('#') !== -1) {
    // current url has a #hash in it
    $('.o-page > .o-page__inner').css('overflow', 'initial');
  }
})($);